import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { tokens } from "styles/Tokens";
import Typography from "../Typography";

interface Props {
  title: string;
  url?: string;
  openInNewTab?: boolean;
}
export default function Index(props: Props) {
  const { title, url, openInNewTab } = props;
  return (
    <Box
      sx={{
        border: `solid 1px ${tokens.Border.General.Tertiary}`,
        borderRadius: "8px",
        padding: "8px 16px 8px 8px",
        marginY: "10px",
        minHeight: "56px",
        display: "flex",
        alignItems: "center",
        overflowWrap: "anywhere"
      }}
    >
      <Link sx={{ marginLeft: "20px" }} href={url} target={openInNewTab ? "_blank" : "_self"} underline="none">
        <Typography variant="body2" color={tokens.Text.General.Color} showBold>
          {title}
        </Typography>
      </Link>
    </Box>
  );
}
